/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Open_RoundsInputs */



/**
* | output |
* | --- |
* | "Open Rounds" |
*
* @param {Tfield_Open_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_open_rounds = /** @type {((inputs?: Tfield_Open_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Open_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes ouvertes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas abiertas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas Abertas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round Aperti")
	return /** @type {LocalizedString} */ ("Open Rounds")
});